// extracted by mini-css-extract-plugin
module.exports = {"nav":"MainNavigation_nav__0bHL3","listItem":"MainNavigation_listItem__C4_bp","link":"MainNavigation_link__BKOJF","linkActive":"MainNavigation_linkActive__Z8TQs"};